var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VFlex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.pagesTotal > 1)?_c('VPagination',{attrs:{"length":_vm.pagesTotal,"value":_vm.pageIndex},on:{"input":function (val) { return _vm.pageIndex = val; }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }